import styled from 'styled-components'

export const WrapperMobileModal = styled.div`
  padding: 16px;
`
